import { render, staticRenderFns } from "./ProjectsModal.vue?vue&type=template&id=902f8e1a&scoped=true"
import script from "./ProjectsModal.vue?vue&type=script&lang=ts"
export * from "./ProjectsModal.vue?vue&type=script&lang=ts"
import style0 from "./ProjectsModal.vue?vue&type=style&index=0&id=902f8e1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "902f8e1a",
  null
  
)

export default component.exports